import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { AgGridAngular } from '@ag-grid-community/angular';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import {
  NoDecimalCellRenderer,
  PercentageCellRenderer,
  DecimalCellRenderer,
} from 'app/utils/ag-grid.locale';
import * as _ from 'lodash';
import { AppState } from 'app/reducers';
import { Store, select } from '@ngrx/store';
import { PayrollUISelectors } from '../../selectors';
import { PayrollUIActions } from '../../actions';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-payroll-synthese',
  templateUrl: './payroll-synthese.component.html',
  styleUrls: ['./payroll-synthese.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PayrollSyntheseComponent implements OnInit, OnChanges, OnDestroy {
  public gridApi;
  public gridColumnApi;

  public columnDefs;
  public defaultColDef;
  public statusBar;
  public rowBuffer;
  public localeText;
  public modules;

  public unsubscribeAll: Subject<any>;

  viewType: 'cash' | 'percentage' | 'person' = 'cash';
  axeSelected = '';

  // tslint:disable-next-line: no-input-rename
  @Input('data') rows: any[] = [];
  @Input() ana2Rows: any[];
  @Input() years: string[];
  @Input() extras: any[] = [];

  @Output() viewTypeChanged = new EventEmitter();

  private _search = '';

  @Input()
  set search(value: string) {
    this._search = value;
    if (this.gridApi) {
      this.gridApi.setQuickFilter(value);
    }
  }

  @ViewChild('agGrid', { static: false }) agGrid: AgGridAngular;

  constructor(protected store: Store<AppState>) {
    this.modules = AllModules;
    this.unsubscribeAll = new Subject();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  ngOnInit(): void {
    this.rebuildSelectExtra();

    this.store
      .pipe(
        takeUntil(this.unsubscribeAll),
        select(PayrollUISelectors.selectSelectdFilterSynthese)
      )
      .subscribe((selected: string) => (this.axeSelected = selected));

    this.store
      .pipe(
        takeUntil(this.unsubscribeAll),
        select(PayrollUISelectors.selectViewTypeSynthese)
      )
      .subscribe((viewType: any) => (this.viewType = viewType));
  }

  rebuildSelectExtra(): void {
    if (this.extras.length > 0) {
      if (typeof this.extras[0] === 'object') {
        this.extras = this.extras
          .filter((extra) => extra.applicable)
          .map((ex) => ex.name);
        this.extras.push('Analytics');
      }
    }
  }

  ngOnChanges(simpleChange: SimpleChanges): void {
    if (simpleChange.years && simpleChange.years.previousValue) {
      this.rebuildSelectExtra();
    }

    if (simpleChange.rows && simpleChange.rows.previousValue) {
      this.rebuildSelectExtra();
      this.onGridReady(this.agGrid);
    }
  }

  getColumnDefs(): any[] {
    return [
      {
        headerName: '',
        field: 'choice',
        pinned: 'left',
        width: 85,
      },
    ];
  }

  setCellRender(
    viewType: string,
    axeSelected: string,
    hasChange: string
  ): void {
    const cellRenderer = {
      percentage: PercentageCellRenderer,
      person: NoDecimalCellRenderer,
      cash: DecimalCellRenderer,
    };

    this.columnDefs = this.columnDefs.map((col, index) => {
      if (index > 0) {
        if (col.children) {
          col.children = col.children.map((c) => {
            c.cellRenderer = cellRenderer[viewType];
            return c;
          });
        }
      }
      return col;
    });

    this.gridApi.setColumnDefs(this.columnDefs);

    if (axeSelected === 'Analytics') {
      this.viewTypeChanged.emit({
        viewType,
        axeSelected,
        entries: this.ana2Rows,
      });
    } else {
      this.viewTypeChanged.emit({ viewType, axeSelected });
    }

    this.store.dispatch(
      PayrollUIActions.payrollSetSelectedFilterSynthese({
        selectedFilterSynthese: axeSelected,
      })
    );

    this.store.dispatch(
      PayrollUIActions.payrollSetViewTypeSynthese({
        selectViewTypeSynthese: viewType,
      })
    );

    // selectViewTypeSynthese

    setTimeout(() => this.autoSizeAll(this.agGrid));
  }

  onGridReady(params): void {
    this.gridApi = params.api;
    this.columnDefs = this.getColumnDefs();

    // Column start timeline
    let colCountPosition = 0;

    // Add timeline
    this.years.forEach((selectedYear) => {
      colCountPosition++;
      // Add flux to column
      this.columnDefs.push({
        headerName: selectedYear,
        children: [],
      });

      this.columnDefs[colCountPosition].children.push({
        headerName: 'Total',
        field: 'totalFlux' + selectedYear,
        cellClass: ['ag-numeric-cell'],
        cellRenderer: DecimalCellRenderer,
        aggFunc: 'sum',
        valueGetter: ({ data }) => {
          let res = null;
          if (data) {
            res = data.items.reduce((prev, curr) => {
              if (curr.timeline.indexOf(selectedYear) > -1) {
                return prev + curr.value;
              }
              return prev;
            }, 0);

            if (this.viewType === 'percentage') {
              return (res = res / 12);
            }
          }
          return res;
        },
        width: 100,
        columnGroupShow: 'open',
      });
      new Array(12).fill(0).forEach((d, index) => {
        const timelineKey = `${selectedYear}-${
          index < 9 ? '0' + (index + 1) : index + 1
        }`;
        this.columnDefs[colCountPosition].children.push({
          headerName: timelineKey,
          width: 100,
          columnGroupShow: 'closed',
          cellClass: ['ag-numeric-cell'],
          // tslint:disable-next-line: no-shadowed-variable
          cellRenderer: (params) => {
            if (this.viewType === 'percentage') {
              return PercentageCellRenderer(params);
            }
            return DecimalCellRenderer(params);
          },
          aggFunc: 'sum',
          valueGetter: ({ data }) => {
            if (data) {
              // tslint:disable-next-line: no-shadowed-variable
              const index = _.findIndex(
                data.items,
                ({ timeline }) => timeline === timelineKey
              );
              return index > -1 ? data.items[index].value : null;
            }
            return null;
          },
        });
      });
    });

    this.columnDefs[0].cellClass = ({ data }) => {
      if (data && data.choice === 'N/A') {
        return ['extra-column'];
      }
      return null;
    };

    this.gridApi.setRowData(this.rows);
    this.gridColumnApi = params.columnApi;
    this.gridApi.setQuickFilter(this._search);
    setTimeout(() => this.autoSizeAll(params));
  }

  public clearSearch(): void {
    this.gridApi.setQuickFilter('');
  }

  onFirstDataRendered(params): void {
    setTimeout(() => this.autoSizeAll(params));
  }

  onRowDataUpdated(params): void {
    setTimeout(() => this.autoSizeAll(params));
  }

  private autoSizeAll(params): void {
    const allColumnIds = params.columnApi
      .getAllColumns()
      .map((column) => column.colId);
    setTimeout(() => params.columnApi.autoSizeColumns(allColumnIds), 0);
  }
}
